import { Flex, Paragraph } from '@vimeo/bokeh';
import { CircleExclamation } from '@vimeo/bokeh-icons';

import * as draftCopy from '../../copy/draft';

export function ClipInterractionsLimitError({ iconSize }: { iconSize: 'xs' | 'sm' }) {
  return (
    <Flex
      w="100%"
      h="100%"
      gap="8px"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
    >
      <CircleExclamation boxSize={iconSize} color="text-primary" />
      <Paragraph p="0 12px" textAlign="center" size="md" color="text-primary">
        {draftCopy.qnaInterractionsLimitError}
      </Paragraph>
    </Flex>
  );
}
